import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { getCoreApiGatewayKeysSlice } from './get';

export const coreApiGatewayKeysUpdateSyncSlice = createUpdateSyncSlice({
	name: 'CoreApiGatewayKeys',
	state: getCoreApiGatewayKeysSlice.asyncState,
	transform: (action: { apiKeyId: number; label: string }, state) => ({
		apiGatewayKey: state?.apiGatewayKey.map((key) =>
			(key.id === action.apiKeyId ?
				{
					...key,
					label: action.label
				} :
				key)) ?? []
	})
});
